import React from 'react';
import { Link } from 'react-router-dom';
import type { IBlog } from '../../types/blog';
import { Clock, User } from 'lucide-react';

interface BlogCardProps {
  blog: IBlog;
}

const BlogCard: React.FC<BlogCardProps> = ({ blog }) => {
  return (
    <Link to={`/blogs/${blog.slug}`} className="block group">
      <div className="bg-white rounded-lg shadow-lg overflow-hidden h-full flex flex-col group-hover:shadow-xl transition-shadow duration-300">
        <div className="overflow-hidden">
          <img
            src={blog.image || '/default-blog-image.jpg'}
            alt={blog.title}
            className="w-full h-56 object-cover group-hover:scale-105 transition-transform duration-300"
          />
        </div>
        <div className="p-6 flex-1 flex flex-col">
          <div>
            {blog.tags && blog.tags.length > 0 && (
              <p className="text-xs text-blue-600 font-semibold mb-2">
                {blog.tags.join(', ').toUpperCase()}
              </p>
            )}
            <h3 className="text-xl font-bold text-gray-900 mb-3">{blog.title}</h3>
          </div>
          <div className="mt-auto pt-4 border-t border-gray-100 flex items-center justify-between text-sm text-gray-500">
            <div className="flex items-center">
              <User size={14} className="mr-2" />
              <span>{blog.authorName}</span>
            </div>
            <div className="flex items-center">
              <Clock size={14} className="mr-2" />
              <span>{blog.readingTime} min read</span>
            </div>
          </div>
        </div>
      </div>
    </Link>
  );
};

export default BlogCard;